import React from "react";
import Sidebar from "./Sidebar";
import { Menu, Database } from "lucide-react";
import { useUIStore } from "../../store/uiStore";
import { useSiteName } from "../../hooks/useSiteName";

export default function AppShell({ children, title, subtitle, actions }) {
  const showHeader = Boolean(title || subtitle || actions);
  const openMobileSidebar = useUIStore((s) => s.openMobileSidebar);
  const siteName = useSiteName();

  return (
    <div className="min-h-screen flex bg-white text-zinc-950">
      <Sidebar />
      <main className="flex-1 flex flex-col min-w-0">
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center justify-between px-4 py-3 border-b border-zinc-200 bg-white sticky top-0 z-20">
          <button
            data-testid="mobile-menu-button"
            onClick={openMobileSidebar}
            className="p-2 rounded-md border border-zinc-200 text-zinc-700 hover:text-zinc-950 hover:border-zinc-950"
            title="Open menu"
          >
            <Menu className="h-5 w-5" />
          </button>
          <div className="flex items-center gap-2">
            <Database className="h-4 w-4 text-zinc-950" strokeWidth={2.5} />
            <span
              className="text-sm font-black tracking-tight text-zinc-950"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              {siteName}
            </span>
          </div>
          <div className="w-9" />
        </div>

        {showHeader && (
          <header className="border-b border-zinc-200 px-4 sm:px-6 md:px-8 py-4 md:py-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4 bg-white">
            <div className="min-w-0">
              {title && (
                <h1
                  className="text-2xl sm:text-3xl font-black tracking-tight text-zinc-950 truncate"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                  data-testid="page-title"
                >
                  {title}
                </h1>
              )}
              {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
          </header>
        )}
        <div className="flex-1 min-w-0 min-h-0">{children}</div>
      </main>
    </div>
  );
}
